import { Compass } from "lucide-react";
import { PublicShell } from "@/components/layout/PublicShell";
import { ButtonLink, EmptyState } from "@/components/system";
import { SEO } from "@/lib/seo";

export default function NotFound() {
  return (
    <PublicShell>
      <SEO
        title="Page not found · PulseBoard"
        description="The page you're looking for doesn't exist or has moved."
        path="/404"
        noindex
      />
      <div className="ds-container ds-container--narrow">
        <div className="ds-section">
          <EmptyState
            icon={<Compass />}
            title="This page doesn't exist"
            action={
              <div className="ds-cluster">
                <ButtonLink to="/directory">Find a specialist</ButtonLink>
                <ButtonLink to="/" variant="secondary">Go to the home page</ButtonLink>
              </div>
            }
          >
            The link may be out of date, or the page may have moved.
          </EmptyState>
        </div>
      </div>
    </PublicShell>
  );
}
